var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-311 -167)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -286,
    y: -22,
    width: 1536,
    height: 100,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6665,
    y: 15,
    width: 26.6667,
    height: 21.6667,
    rx: 3,
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 19.6667,
    x2: 41,
    y2: 19.6667,
    stroke: "#EBEFF2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6714 18C12.6714 16.3431 14.0145 15 15.6714 15H36.3414C37.9982 15 39.3414 16.3431 39.3414 18V19H12.6714V18Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 33.3334,
    r: 6.75,
    fill: "#9BBCCB",
    stroke: "#EBEFF2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 33.8334H36V30.8334",
    stroke: "#EBEFF2",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -288,
    y: -22,
    width: 1540,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-311 -167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.d3aa2711a6e37e750144625588ec4305.svg";
export { ForwardRef as ReactComponent };